import connect from '@clearscore/redux.connect';
import { actions as alertActions, selectors as alertSelectors } from '@clearscore/redux.alerts';
import { NotificationController } from '@clearscore/rainbow.notification';

const toUpper = (v) => (typeof v === 'string' ? v.toUpperCase() : v);

const mapState = (state) => {
    const {
        isAlertOpen: isOpen,
        alertType: theme,
        alertCloseText,
        alertContent: children,
        duration,

        ctaText = alertCloseText,
        isDismissible,
        alertId,
        href,
        title,
        isNewTab,
    } = alertSelectors.getAlert(state);

    const props = {
        isOpen,
        // NOTE: there is mismatch in constants between rainbow and
        //       rest of the system rainbow use UPPERCASE.
        theme: toUpper(theme),
        ctaText,
        children,
        duration,
        isDismissible,
        alertId,
        href,
        title,
        isNewTab,
        dataId: theme,
    };

    return props;
};

const mapDispatch = {
    onDismiss: alertActions.delayedDismissAlert,
    // NOTE: previous alert used cta for closing only.
    ctaHandler: alertActions.dismissAlert,
};

export default connect(mapState, mapDispatch)(NotificationController);
